"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sredDocumentationStatusLabel = exports.SredDocumentationStatus = void 0;
var SredDocumentationStatus;
(function (SredDocumentationStatus) {
    SredDocumentationStatus["COMPLETE"] = "COMPLETE";
    SredDocumentationStatus["INCOMPLETE"] = "INCOMPLETE";
    SredDocumentationStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(SredDocumentationStatus || (exports.SredDocumentationStatus = SredDocumentationStatus = {}));
exports.sredDocumentationStatusLabel = {
    [SredDocumentationStatus.COMPLETE]: 'Complete',
    [SredDocumentationStatus.INCOMPLETE]: 'Incomplete',
    [SredDocumentationStatus.NOT_APPLICABLE]: 'Not Applicable',
};
